module.exports = __webpack_public_path__ + "static/media/60.b1ce1376.jpg";